import { Input } from 'components';
/*
 * If I can delete this file
 * No specific code for the client left
 */

export const RCSpecialConf = {
  orgId: 'b5df4f31-11b0-4efb-afbd-55c0b081b4e1',
  panelId: 'f9602be5-cd8f-4501-a6d2-780d45937424',
  specialFields: [
    {
      name: '__rcDevice',
      participantLabel: 'Device',
      clientLabel: 'Device',
      formComponent: Input,
    },
  ],
};
